import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { useSelector } from 'react-redux'
import prepareHeaders from '../utils/prepareHeaders'
import { getSelectedCustomerId, getSelectedOrFirstCustomerId } from '../selectors/customers'

export const secureApi = createApi({
  reducerPath: 'securePosture',
  baseQuery: fetchBaseQuery({
    prepareHeaders,
    baseUrl: process.env.REACT_APP_AUGMENTT_API_URL,
  }),
  endpoints: (builder) => ({
    keepUnusedDataFor: Infinity,
    getSecurityPosture: builder.query({
      query: (customerId = '*') => `/secure/posture/${customerId}`,
    }),
  }),
})

export const { useGetSecurityPostureQuery, useLazyGetSecurityPostureQuery } = secureApi

export const useGetCustomerSecurityPosture = (supportAllCompanies = true) => {
  const customerId = useSelector(supportAllCompanies ? getSelectedCustomerId : getSelectedOrFirstCustomerId)

  return useGetSecurityPostureQuery(customerId)
}

export const useGetCustomerSecurityPostureChecks = () => {
  const result = useGetCustomerSecurityPosture(false)
  const { data } = result

  if (!data) {
    return result
  }

  const { securityChecks: { allMonitored = [], ignored = [] } = {} } = data

  return {
    ...result,
    data: [...allMonitored, ...ignored],
  }
}
